import DefaultHero from './DefaultHero';

export default DefaultHero;
